import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/bancos/1touchpay`;

export const useLedgerCandidates = mov => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const flight = useRef(null);
  const currentId = useRef(mov?.otp_id);
  currentId.current = mov?.otp_id;
  const id = mov?.otp_id;
  const amount = mov?.importe;
  const search = useCallback(async (q = '') => {
    flight.current?.abort();
    if (id == null) return;
    const abort = new AbortController();
    flight.current = abort;
    setLoading(true);
    setError('');
    try {
      const params = { limit: 50, ...(q.trim() ? { q: q.trim() } : { amount }) };
      const { data } = await axios.get(`${API}/unmatched-receipts`, {
        params, signal: abort.signal, timeout: 20000, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (!abort.signal.aborted && currentId.current === id) setResult({ id, items: data.items || [] });
    } catch (e) {
      if (!abort.signal.aborted && currentId.current === id) setError('No se pudieron cargar los comprobantes. Reintentá la búsqueda.');
    } finally {
      if (!abort.signal.aborted && currentId.current === id) setLoading(false);
    }
  }, [id, amount]);
  useEffect(() => { setResult(null); search(); return () => flight.current?.abort(); }, [search]);
  return { candidates: result != null && result.id === id ? result.items : [], loading, error, search };
};